import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";

export interface JobOGImageData {
  title: string;
  location: string;
  workType?: string;
  company: string;
  logo?: string;
}

@Injectable({
  providedIn: "root",
})
export class OgImageService {
  /**
   * Generates the URL for an Open Graph image for a job posting
   * @param jobData - The job data to include in the image
   * @returns The URL to the generated OG image
   */
  generateJobOGImageUrl(jobData: JobOGImageData): string {
    const params = new URLSearchParams({
      title: jobData.title,
      location: jobData.location,
      company: jobData.company,
    });

    // Add optional parameters if they exist
    if (jobData.workType) {
      params.set("workType", jobData.workType);
    }

    if (jobData.logo) {
      params.set("logo", jobData.logo);
    }

    // Use new OG subdomain for image generation
    return `https://og.designjobs.careers/api/og/job?${params.toString()}`;
  }

  /**
   * Helper method to extract OG image data from a job object
   * This assumes your existing Job model structure
   */
  extractJobOGData(job: any): JobOGImageData {
    let logo = job.logo_img || job.company_logo || job.companyLogo || "";
    
    // Skip logo if it's a base64 data URI (too long for URL params)
    // Only use logo if it's an actual URL
    if (logo && logo.startsWith('data:')) {
      logo = "";
    }
    
    return {
      title: job.title || "Job Position",
      location: job.display_location || job.location || "Remote",
      workType: job.work_type || job.workType,
      company: job.company || "Company",
      logo: logo,
    };
  }
}
